module.exports = __webpack_public_path__ + "static/media/mri-icon2.1cde1494.png";